import React from "react";

function TableRowError({ columns, emptyRowHeight, rowHeight, error }) {
  return (
    <>
      <tr className="text-center align-middle" style={{ height: rowHeight }}>
        <td colSpan={columns.length}>
          {error?.message ?? "Error occured while downloading data"}
        </td>
      </tr>
      <tr height={emptyRowHeight} />
    </>
  );
}

export default TableRowError;
